import TestPart from '../../app/features/TestPart';
const TestPagePart = () => {
  return <TestPart />
}
export default TestPagePart